// removed by extract-text-webpack-plugin
module.exports = {"container":"IkkOq","body":"_2SX3-","title":"UIJh0","subtitle":"IRsDL","content":"_2tm-n","action":"fnCPu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Testimonials.less
// module id = ./src/components/Home/Testimonials.less
// module chunks = 2